/**
 * QR Code da indicação pela web (pedido de 19/10, item 9): gerado no PRÓPRIO navegador do Master
 * (lib npm "qrcode"), sem serviço externo. PNG e SVG para baixar e o cartaz para impressão.
 */
import QRCode from "qrcode";
import { htmlCartaz } from "@/lib/indicacaoWeb";

const OPCOES = { errorCorrectionLevel: "M", margin: 2, color: { dark: "#000000", light: "#FFFFFF" } };

/** PNG (data URL) do QR. `largura` em pixels (1024 para impressão nítida). */
export function qrPngDataUrl(texto, largura = 1024) {
  return QRCode.toDataURL(String(texto || ""), { ...OPCOES, width: largura, type: "image/png" });
}

/** SVG (texto) do QR, vetorial para gráfica. */
export function qrSvg(texto) {
  return QRCode.toString(String(texto || ""), { ...OPCOES, type: "svg" });
}

function baixarHref(href, nome) {
  const a = document.createElement("a");
  a.href = href;
  a.download = nome;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** Baixa o PNG do QR. */
export async function baixarQrPng(texto, nome) {
  const url = await qrPngDataUrl(texto, 1024);
  baixarHref(url, nome);
}

/** Baixa o SVG do QR. */
export async function baixarQrSvg(texto, nome) {
  const svg = await qrSvg(texto);
  const blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
  const href = URL.createObjectURL(blob);
  baixarHref(href, nome);
  setTimeout(() => URL.revokeObjectURL(href), 10000);
}

/**
 * Imprime o cartaz da unidade num iframe escondido (sem janela nova: não esbarra no bloqueio de
 * pop-up). Espera as imagens (logo) carregarem antes de abrir a impressão.
 */
export async function imprimirCartaz({ unidadeNome, url, logoUrl }) {
  const svg = await qrSvg(url);
  const html = htmlCartaz({ unidadeNome, url, svg, logoUrl });
  const ifr = document.createElement("iframe");
  ifr.setAttribute("aria-hidden", "true");
  ifr.title = "Cartaz da indicação";
  Object.assign(ifr.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  document.body.appendChild(ifr);
  const win = ifr.contentWindow;
  const doc = win.document;
  doc.open();
  doc.write(html);
  doc.close();
  await Promise.all(Array.from(doc.images || []).map((img) => (img.complete ? null
    : new Promise((ok) => { img.onload = ok; img.onerror = ok; }))));
  const remover = () => { if (ifr.parentNode) ifr.parentNode.removeChild(ifr); };
  try {
    win.addEventListener("afterprint", () => setTimeout(remover, 500));
  } catch (_) { /* navegador sem afterprint */ }
  setTimeout(remover, 120000);
  win.focus();
  win.print();
}
